import React, { useState } from 'react';
import { Table } from 'react-bootstrap';
import { MemberModal } from '../individual/MemberModal'
import '../../../styles/MembersTable.css';
import { needsChrId } from '../../utility/needsChrId';

export const HHIERows = (props) => {
    const [member, setMember] = useState(null);
    const [showMemberModal, setShowMemberModal] = useState(false);

    const renderTable = () => {
        return props.members.map(member => {
            const showProblem = needsChrId(member);
            return (
                <tr key={member.id}
                    // className={showProblem ? "red-table-row" : ""}
                    // style={showProblem ? { background: '#ff000061' } : {}}
                    // onMouseEnter={(e) => {
                    //     if (showProblem) {
                    //         e.target.style.background = 'red';
                    //     }
                    // }}
                    // onMouseLeave={(e) => {
                    //     if (showProblem) {
                    //         e.target.style.background = '#ff000061';
                    //     }
                    // }}
                    onClick={
                        () => {
                            setMember(member);
                            setShowMemberModal(true);
                        }
                    }
                >
                    <td>{member.account.legalName}</td>
                    <td style={showProblem ? { background: '#ff000061' } : {}}>
                        {member.lastName + ', ' + member.firstName + ' ' + (member.middleName??"")}
                    </td>
                    <td style={
                        { color: member.passStatus.npiPassStatus === 'FAIL' ? 'red' : '' }
                    }>
                        {member.passStatus.npiPassStatus}
                    </td>
                    <td style={
                        { color: member.passStatus.dccaPassStatus === 'FAIL' ? 'red' : '' }
                    }>
                        {member.passStatus.dccaPassStatus}
                    </td>
                    <td style={
                        { color: member.passStatus.oigPassStatus === 'FAIL' ? 'red' : '' }
                    }>
                        {member.passStatus.oigPassStatus}
                    </td>
                    <td style={
                        { color: member.passStatus.samPassStatus === 'FAIL' ? 'red' : '' }
                    }>
                        {member.passStatus.samPassStatus}
                    </td>
                    <td style={{ color: member.passStatus.overallPassed !== 'PASS' ? 'red' : 'green' }}>{member.passStatus.overallPassed}</td>
                    <td>{member.status ? member.status : "Unknown"}</td>
                    <td>{member.passStatus.readablePassedDate}</td>
                </tr>
            );
        });
    }
    return (
        <>
            <Table
                id={props.id}
                className="all-members-table"
                striped
                bordered
                hover
                responsive="md"
                variant="light">
                <thead>
                    <tr>
                        <th>Account</th>
                        <th>Name</th>
                        <th>NPI</th>
                        <th>DCCA</th>
                        <th>LEIE</th>
                        <th>SAM</th>
                        <th>Final</th>
                        <th>Status</th>
                        <th>Last Provision</th>
                    </tr>
                </thead>
                <tbody>{renderTable()}</tbody>
            </Table>
            {member && <MemberModal member={member} show={showMemberModal} onHide={() => { setShowMemberModal(false); }} />}
        </>
    );
}